import { render, staticRenderFns } from "./CommunicationManagementForm.vue?vue&type=template&id=228e7eee&scoped=true"
import script from "./CommunicationManagementForm.vue?vue&type=script&lang=js"
export * from "./CommunicationManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e7eee",
  null
  
)

export default component.exports